import { tsValidateValue } from '@nu-art/ts-common';
import { TopicAllowedCollectionNames } from '@app/shared';
import { DBDef_Topic, Validator_GeneratedProps_Topic } from '@nu-art/ts-messaging-shared';
DBDef_Topic.generatedPropsValidator = {
    ...Validator_GeneratedProps_Topic,
    type: tsValidateValue(TopicAllowedCollectionNames),
};
